/**
 * Performs a multi-word search where ALL words must be present in the text
 * @param text - The text to search in
 * @param searchQuery - The search query containing one or more words
 * @returns true if all words in the query are found in the text
 */
export function multiWordSearch(text: string, searchQuery: string): boolean {
    if (!searchQuery.trim()) {
        return true;
    }

    const normalizedText = text?.toLowerCase() || '';
    const searchWords = searchQuery?.toLowerCase().trim().split(/\s+/) || [];

    return searchWords.every(word => normalizedText.includes(word));
}

/**
 * Filters an array of items based on multi-word search
 * @param items - Array of items to filter
 * @param searchQuery - The search query
 * @param getText - Function to extract searchable text from an item
 * @returns Filtered array where all search words are found in item text
 */
export function filterByMultiWordSearch<T>(
    items: T[],
    searchQuery: string,
    getText: (item: T) => string
): T[] {
    if (!searchQuery.trim()) {
        return items;
    }

    return items.filter(item => multiWordSearch(getText(item), searchQuery));
}